document.addEventListener('DOMContentLoaded', function () {
  const variantMeta   = JSON.parse(document.getElementById('VariantMeta')?.textContent || '[]');
  const purchasedSkus = JSON.parse(document.getElementById('customerPurchasedSkus')?.dataset.value || '[]');
  const productForm   = document.querySelector('product-form');

  if (!productForm) return;

  // Add To Cart ボタン & hidden variant input
  const submitBtn = productForm.querySelector('button[type="submit"][name="add"]');
  const idInput   = productForm.querySelector('input[name="id"]');
  if (!submitBtn) return;

  // ▼ ゲート連携ヘルパー（個数制限ロック）
  function lockByLimit(limit) {
    const msg = `こちらの商品はすでに購入済みです<br>（お一人様上限 ${limit} 点）`;
    submitBtn.setAttribute('data-pl-lock', '1');
    if (typeof window.__updateCartButtonGate === 'function') {
      window.__updateCartButtonGate({ plMessage: msg });
    }
  }

  function unlockLimit() {
    submitBtn.removeAttribute('data-pl-lock');
    if (typeof window.__updateCartButtonGate === 'function') {
      window.__updateCartButtonGate({ plMessage: '' });
    }
  }

  // ▼ 実際の判定ロジック
  function evaluateLimit() {
    // 毎回いったん解除から
    unlockLimit();

    // ---- バリエーション商品の処理（現在の variant ID ベース）----
    var currentVariantId = null;
    if (idInput && idInput.value) {
      currentVariantId = parseInt(idInput.value, 10);
    }

    if (currentVariantId && variantMeta.length > 0) {
      var variantData = variantMeta.find(function(v){
        return String(v.id) === String(currentVariantId);
      });

      if (variantData && variantData.limit > 0 && variantData.sku) {
        var purchasedCount = purchasedSkus.filter(function(sku){
          return sku === variantData.sku;
        }).length;

        if (purchasedCount >= variantData.limit) {
          // 上限到達 → ロック
          lockByLimit(variantData.limit);
        } else {
          // 上限未満 → ロック解除
          unlockLimit();
        }
      } else {
        // limit が 0 など → 制限なし
        unlockLimit();
      }
      return; // バリエーション商品の場合はここで終了
    }

    // ---- バリエーションなし商品の処理（data-sku / data-limit 利用）----
    const sku   = productForm.dataset.sku;
    const limit = parseInt(productForm.dataset.limit, 10);

    if (sku && limit > 0) {
      const purchasedCount = purchasedSkus.filter(s => s === sku).length;
      if (purchasedCount >= limit) {
        lockByLimit(limit);
      } else {
        unlockLimit();
      }
    } else {
      unlockLimit();
    }
  }

  // 初回
  evaluateLimit();

  // ▼ hidden input[name="id"] の value 変化を監視（バリエーション切替対応）
  if (idInput) {
    const mo = new MutationObserver(function () {
      evaluateLimit();
    });
    mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  // テーマ側が variant:changed を飛ばしている場合も拾っておく（保険）
  document.addEventListener('variant:changed', function () {
    evaluateLimit();
  }, { passive: true });
});

// (() => {
//   'use strict';

//   const isImage = (el) => !!el.closest('img, picture, figure, .product-media, .media');

//   // 右クリック（画像だけ）
//   document.addEventListener('contextmenu', (e) => {
//     if (isImage(e.target)) e.preventDefault();
//   }, { capture: true });

//   // ドラッグ保存（画像だけ）
//   document.addEventListener('dragstart', (e) => {
//     if (isImage(e.target)) e.preventDefault();
//   }, { capture: true });

//   // 右ボタン押下（保険）
//   document.addEventListener('mousedown', (e) => {
//     if (e.button === 2 && isImage(e.target)) e.preventDefault();
//   }, { capture: true });

//   // 画像選択コピー防止
//   document.addEventListener('selectstart', (e) => {
//     if (isImage(e.target)) e.preventDefault();
//   }, { capture: true });

// })();